import { connect } from 'react-redux';
import _ from 'lodash';
import VisitorCheckoutForm from './VisitorCheckoutForm';
import VisitorCheckinForm from './VisitorCheckinForm';
import VisitorAccess from './VisitorAccess';
import { loadingSelector, visitorSelector, goToSelector, matchesSelector } from '../../../../selectors/whiteLabel/visitor';
import { allowCheckin, checkinVisitor, checkoutVisitor, setGoTo } from '../../../../actions/whiteLabel/visitor';
import { translations } from '../../../../selectors/translations';

const mapStateToPropsCheckin = state => ({
  translations: _.get(translations(state), 'visitors', {}),
  isLoading: loadingSelector(state),
  goTo: goToSelector(state),
  matches: matchesSelector(state),
});

const mapStateToPropsCheckout = state => ({
  translations: _.get(translations(state), 'visitors', {}),
  visitorName: visitorSelector(state),
  isLoading: loadingSelector(state),
  goTo: goToSelector(state),
});

const mapDispatchPropsCheckin = dispatch => {
  return {
    allowCheckin: data => dispatch(allowCheckin(data)),
    checkinVisitor: data => dispatch(checkinVisitor(data)),
    setGoTo: data => dispatch(setGoTo(data)),
  };
};

const mapDispatchPropsCheckout = dispatch => {
  return {
    checkoutVisitor: data => dispatch(checkoutVisitor(data)),
    setGoTo: data => dispatch(setGoTo(data)),
  };
};

const CheckinPage = connect(mapStateToPropsCheckin, mapDispatchPropsCheckin)(VisitorCheckinForm);
const CheckoutPage = connect(mapStateToPropsCheckout, mapDispatchPropsCheckout)(VisitorCheckoutForm);
const VisitorAccessPage = connect(mapStateToPropsCheckin, mapDispatchPropsCheckin)(VisitorAccess);

export { CheckinPage, CheckoutPage, VisitorAccessPage };
